export default {
  boundariesAndDescriptors: 'Boundaries And Descriptors'
}
